/** The AB Test branch variations. */
export enum Variation {
  A = 'T_A',
  B = 'T_B',
  C = 'T_C',
  D = 'T_D',
}

/** The available AB Test triggers. */
export type Triggers = 'load' | 'click' | 'delay' | 'redirect' | 'submit' | 'scroll' | 'visible';

/** The AB Test context props. */
export interface ContextProps {
  /** The branch the AB Test should be using. */
  branch: string | null;
  /** The trigger that enables the AB Test. */
  trigger: Triggers;
  /** Checks if the trigger has fired for the AB Test. */
  hasTriggerFired: boolean;
  /** The selector used in the AB Test. */
  selector?: string;
  /** A function that triggers the AB Test. */
  triggerCurrentTest: () => void;
  /** Determins if the AB Test shield should be displayed. */
  shouldShowShield?: boolean;
}
